/**
 * Created by handd on 2021/10/27.
 * 消息类型管理
 */
import axios from "axios";
import {message} from "antd";

// const
const MESSAGE_TYPE_TOGGLE_LOADING = "messageType/MESSAGE_TYPE_TOGGLE_LOADING";//加载标志
const MESSAGE_TYPE_TOGGLE_BUTTON_LOADING = "messageType/MESSAGE_TYPE_TOGGLE_BUTTON_LOADING";//提交加载标志
const MESSAGE_TYPE_UPDATE_DATA = "messageType/MESSAGE_TYPE_UPDATE_DATA";
const MESSAGE_TYPE_STORE_MESSAGE_CATEGORIES = "messageType/MESSAGE_TYPE_STORE_MESSAGE_CATEGORIES";
const MESSAGE_TYPE_STORE_MESSAGE_GROUPS = "messageType/MESSAGE_TYPE_STORE_MESSAGE_GROUPS";
const MESSAGE_TYPE_STORE_MESSAGE_TYPES = "messageType/MESSAGE_TYPE_STORE_MESSAGE_TYPES";
const MESSAGE_TYPE_STORE_RELOAD_MESSAGE_TYPES = "messageType/MESSAGE_TYPE_STORE_RELOAD_MESSAGE_TYPES";
const MESSAGE_TYPE_ADD_MESSAGE_TYPE = "messageType/MESSAGE_TYPE_ADD_MESSAGE_TYPE";
const MESSAGE_TYPE_EDIT_MESSAGE_TYPE = "messageType/MESSAGE_TYPE_EDIT_MESSAGE_TYPE";
const MESSAGE_TYPE_VIEW_MESSAGE_TYPE = "messageType/MESSAGE_TYPE_VIEW_MESSAGE_TYPE";

// reducer
export const messageType = (state = {
  loading: false,
  buttonLoading: false,
  addVisible: false,
  editVisible: false,
  viewVisible: false,

  messageCategories: [],
  messageCategory: "",
  messageGroups: [],
  messageTypes: [],
  messageType: {},

}, action) => {
  switch (action.type) {
    case MESSAGE_TYPE_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    case MESSAGE_TYPE_TOGGLE_BUTTON_LOADING:
      return {
        ...state,
        buttonLoading: action.data
      };
    case MESSAGE_TYPE_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case MESSAGE_TYPE_STORE_MESSAGE_CATEGORIES:
      return {
        ...state,
        messageCategories: action.data,
        messageCategory: "",
      };
    case MESSAGE_TYPE_STORE_MESSAGE_GROUPS:
      return {
        ...state,
        messageGroups: action.data,
      };
    case MESSAGE_TYPE_STORE_MESSAGE_TYPES:
      return {
        ...state,
        loading: false,
        buttonLoading: false,
        addVisible: false,
        editVisible: false,
        viewVisible: false,
        messageTypes: action.data.messageTypes,
        messageCategory: action.data.messageCategory,
        messageType: {},
      };
    case MESSAGE_TYPE_STORE_RELOAD_MESSAGE_TYPES:
      return {
        ...state,
        loading: false,
        buttonLoading: false,
        addVisible: false,
        editVisible: false,
        viewVisible: false,
        messageTypes: action.data,
        messageType: {},
      };
    case MESSAGE_TYPE_ADD_MESSAGE_TYPE:
      return {
        ...state,
        messageType: {},
        addVisible: true
      };
    case MESSAGE_TYPE_EDIT_MESSAGE_TYPE:
      return {
        ...state,
        messageType: action.data,
        editVisible: true
      };
    case MESSAGE_TYPE_VIEW_MESSAGE_TYPE:
      return {
        ...state,
        messageType: action.data,
        viewVisible: true
      };
    default:
      return state
  }
};

/**
 * update data based
 */
export const updateMessageTypeData = (data) => {
  return {
    type: MESSAGE_TYPE_UPDATE_DATA,
    data: data
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: MESSAGE_TYPE_TOGGLE_LOADING,
    data: show
  }
};

/**
 * toggle button loading
 */
export const toggleButtonLoading = (show) => {
  return {
    type: MESSAGE_TYPE_TOGGLE_BUTTON_LOADING,
    data: show
  }
};

/**
 * get all message categories
 */
export const getMessageCategories = () => (dispatch) => {
  axios.get(`/api-message/messageCategories`, {contentType: "application/json"}).then(
    response => {
      if (response.status === 200) {
        if (response.data) {
          dispatch(storeMessageCategories(response.data));
        } else {
          message.warning("未获取到消息类别", 3);
        }
      }
    }
  ).catch(err => {
    message.error("获取消息类别错误" + err.data, 3);
  });
};

/**
 * store all message categories
 */
export const storeMessageCategories = (messageCategories) => {
  return {
    type: MESSAGE_TYPE_STORE_MESSAGE_CATEGORIES,
    data: messageCategories
  }
};

/**
 * get all message groups
 */
export const getMessageGroups = () => (dispatch) => {
  axios.get(`/api-message/messageGroups`, {contentType: "application/json"}).then(
    response => {
      if (response.status === 200) {
        if (response.data) {
          dispatch(storeMessageGroups(response.data));
        } else {
          message.warning("未获取到消息组", 3);
        }
      }
    }
  ).catch(err => {
    message.error("获取消息组错误" + err.data, 3);
  });
};

/**
 * store all message groups
 */
export const storeMessageGroups = (messageGroups) => {
  return {
    type: MESSAGE_TYPE_STORE_MESSAGE_GROUPS,
    data: messageGroups
  }
};

/**
 * query all message types
 */
export const queryMessageTypes = (data) => (dispatch) => {
  axios.get(`/api-message/messageTypes?category=${data}`, {contentType: "application/json"}).then(
    response => {
      if (response.status === 200) {
        if (response.data) {
          dispatch(storeMessageTypes({messageTypes: response.data, messageCategory: data}));
          // message.success("查询成功", 1);
        } else {
          message.warning("未获取到消息类型", 3);
        }
      }
    }
  ).catch(err => {
    message.error("获取消息类型错误：" + err.data, 3);
  });
};

/**
 * store all message types
 */
export const storeMessageTypes = (messageTypes) => {
  return {
    type: MESSAGE_TYPE_STORE_MESSAGE_TYPES,
    data: messageTypes
  }
};

/**
 * reload message types
 */
export const reloadMessageTypes = (data) => (dispatch) => {
  axios.get(`/api-message/messageTypes?category=${data}`, {contentType: "application/json"}).then(
    response => {
      if (response.status === 200) {
        if (response.data) {
          dispatch(storeReloadMessageTypes(response.data));
          message.success("刷新成功", 1);
        } else {
          message.warning("未查询到消息类型", 3);
        }
      }
    }
  ).catch(err => {
    message.error("刷新错误：" + err.data, 3);
  });
};


/**
 * store reload message types
 */
export const storeReloadMessageTypes = (messageTypes) => {
  return {
    type: MESSAGE_TYPE_STORE_RELOAD_MESSAGE_TYPES,
    data: messageTypes
  }
};

/**
 * add message type
 */
export const addMessageType = () => {
  return {
    type: MESSAGE_TYPE_ADD_MESSAGE_TYPE,
  }
};

/**
 * edit message type
 */
export const editMessageType = (messageType) => {
  return {
    type: MESSAGE_TYPE_EDIT_MESSAGE_TYPE,
    data: messageType
  }
};

/**
 * view message type
 */
export const viewMessageType = (messageType) => {
  return {
    type: MESSAGE_TYPE_VIEW_MESSAGE_TYPE,
    data: messageType
  }
};

/**
 * submit message type
 */
export const submitMessageType = (data) => (dispatch) => {
  message.loading({content: `保存中……`, key: "submit"});
  axios({
    method: "POST",
    url: `/api-message/messageType`,
    contentType: "application/json",
    withCredentials: true,
    data: data,
  }).then(
    response => {
      if (response.status === 200) {
        message.success({content: `保存成功`, key: "submit", duration: 1});
        data.reload();
      } else {
        message.error({content: `保存失败！`, key: "submit", duration: 3});
        dispatch(toggleButtonLoading(false));
      }
    }
  ).catch(err => {
    message.error({content: "保存错误：" + err.data, key: "submit", duration: 3});
    dispatch(toggleButtonLoading(false));
  });
};


/**
 * delete message type
 */
export const deleteMessageType = (data) => (dispatch) => {
  message.loading({content: "删除中……", key: "delete"});
  axios({
    method: "DELETE",
    url: `/api-message/messageType`,
    contentType: "application/json",
    withCredentials: true,
    data: data.ids,
  }).then(
    response => {
      if (response.status === 200) {
        message.success({content: "删除成功", key: "delete", duration: 1});
        data.reload();
      } else {
        message.error({content: "删除失败", key: "delete", duration: 3});
      }
    }
  ).catch(err => {
    message.error({content: "删除错误：" + err.data, key: "delete", duration: 3});
  });
};
